export const CODE_SUCCESS = 0;
export const CODE_GENERAL_ERROR = 1;
export const CODE_TOKEN_EXPIRED = 2;
export const CODE_NO_VALID_TOKEN = 3;
export const CODE_INVALID_CREDENTIALS = 4;
export const MISSING_PERMISSION = 16001;
export const RESERVATION_ALREADY_PROCESSED = 22000;
